import { toIntlLocale } from './locale';

const KB = 1024;
const MB = 1024 * 1024;

/** Размер файла: «850 КБ», «2,4 МБ» (Intl, единицы на языке интерфейса). */
export function formatFileSize(bytes: number, language: string): string {
  const locale = toIntlLocale(language);
  if (bytes >= MB) {
    return new Intl.NumberFormat(locale, {
      style: 'unit',
      unit: 'megabyte',
      maximumFractionDigits: 1,
    }).format(bytes / MB);
  }
  return new Intl.NumberFormat(locale, {
    style: 'unit',
    unit: 'kilobyte',
    maximumFractionDigits: 0,
  }).format(Math.max(1, Math.round(bytes / KB)));
}

/** Целое число мегабайт для подписей лимитов: «10». */
export function bytesToMegabytes(bytes: number): number {
  return Math.round(bytes / MB);
}

/** Доля 0…1 → «45 %» (Intl). */
export function formatPercent(fraction: number, language: string): string {
  return new Intl.NumberFormat(toIntlLocale(language), {
    style: 'percent',
    maximumFractionDigits: 0,
  }).format(Math.min(1, Math.max(0, fraction)));
}

/** Целое число для показа: «5 120» (Intl на языке интерфейса, без пересчёта значения). */
export function formatInteger(value: number, language: string): string {
  return new Intl.NumberFormat(toIntlLocale(language), { maximumFractionDigits: 0 }).format(value);
}

/** Число с дробной частью для показа: «4,5» (Intl; `digits` — знаков после запятой, ровно). */
export function formatDecimal(value: number, language: string, digits = 1): string {
  return new Intl.NumberFormat(toIntlLocale(language), {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  }).format(value);
}
